module.exports = __webpack_public_path__ + "media/images/japan/schedule_arrow_3-33bb3deaf40a8e0fc559bb1db4c5a82a.svg";